import {
  BooleanParam,
  NumberParam,
  StringParam,
  withDefault,
} from 'use-query-params';

export const queryParams = {
  aboutToExpireThresholdInDays: NumberParam,
  after: StringParam,
  before: StringParam,
  countryCode: StringParam,
  desc: withDefault(BooleanParam, true),
  filterByAmlPercentageAbove: NumberParam,
  first: withDefault(NumberParam, 20),
  ignorePendingValidations: BooleanParam,
  last: NumberParam,
};
